import Vuex from "vuex";
import Vue from "vue";

import { userModule } from "./modules/UserStore";
import { IUserState } from "./states/user-state";

import { userSelectionModule } from "./modules/UserSelectionStore";
import { IUserSelectionState } from "./states/user-selection-state";

import { userManagementModule } from "./modules/UserManagementStore";
import { IUserManagementState } from "./states/user-management-state";

import { publisherModule } from "./modules/PublisherStore";
import { IPublisherState } from "./states/publisher-state";

import { publisherManagementModule } from "./modules/PublisherManagementStore";
import { IPublisherManagementState } from "./states/publisher-management-state";

import { propertyManagementModule } from "./modules/PropertyManagementStore";
import { IPropertyManagementState } from "./states/property-management-state";

import { propertyOverviewModule } from "./modules/PropertyOverviewStore";
import { IPropertyOverviewState } from "./states/property-overview-state";

import { propertyPerformanceModule } from "./modules/PropertyPerformanceStore";
import { IPropertyPerformanceState } from "./states/property-performance-state";

import { zoneManagementModule } from "./modules/ZoneManagementStore";
import { IZoneManagementState } from "./states/zone-management-state";

import { contentSetModule } from "./modules/ContentSetStore";
import { IContentSetState } from "./states/content-set-state";

import { deviceModule } from "./modules/DeviceStore";
import { IDeviceState } from "./states/device-state";

import { processModule } from "./modules/ProcessStore";
import { IProcessState } from "./states/process-state";

import { productModule } from "./modules/ProductStore";
import { IProductState } from "./states/product-state";

import { contentSetVersionModule } from "./modules/ContentSetVersionStore";
import { IContentSetVersionState } from "./states/content-set-version-state";

import { multivariateModule } from "./modules/MultivariateStore";
import { IMultivariateState } from "./states/multivariate-state";

import { contentTemplateModule } from "./modules/ContentTemplateStore";
import { IContentTemplateState } from "./states/content-template-state";

import { contentTypeModule } from "./modules/ContentTypeStore";
import { IContentTypeState } from "./states/content-type-state";

import { zoneEnquiryModule } from "./modules/ZoneEnquiryStore";
import { IZoneEnquiryState } from "./states/zone-enquiry-state";

import { creativeEnquiryModule } from "./modules/CreativeEnquiryStore";
import { ICreativeEnquiryState } from "./states/creative-enquiry-state";

import { contentScenarioTypeModule } from "./modules/ContentScenarioTypeStore";
import { IContentScenarioTypeState } from "./states/content-scenario-type-state";

import { campaignDeliveryTypeModule } from "./modules/CampaignDeliveryTypeStore";
import { ICampaignDeliveryTypeState } from "./states/campaign-delivery-type-state";

Vue.use(Vuex);

export interface RootState {
    userModule: IUserState;
    userManagementModule: IUserManagementState;
    userSelectionModule: IUserSelectionState;
    publisherModule: IPublisherState;
    publisherManagementModule: IPublisherManagementState;
    propertyManagementModule: IPropertyManagementState;
    propertyOverviewModule: IPropertyOverviewState;
    propertyPerformanceModule: IPropertyPerformanceState;
    zoneManagementModule: IZoneManagementState;
    contentSetModule: IContentSetState;
    deviceModule: IDeviceState;
    processModule: IProcessState;
    productModule: IProductState;
    contentSetVersionModule: IContentSetVersionState;
    multivariateModule: IMultivariateState;
    contentTemplateModule: IContentTemplateState;
    contentTypeModule: IContentTypeState;
    zoneEnquiryModule: IZoneEnquiryState;
    creativeEnquiryModule: ICreativeEnquiryState;
    contentScenarioTypeModule: IContentScenarioTypeState;
    campaignDeliveryTypeModule: ICampaignDeliveryTypeState;
}

export const store = new Vuex.Store({
    modules: {
        userModule,
        userManagementModule,
        publisherModule,
        publisherManagementModule,
        propertyManagementModule,
        propertyOverviewModule,
        propertyPerformanceModule,
        zoneManagementModule,
        userSelectionModule,
        contentSetModule,
        deviceModule,
        processModule,
        productModule,
        contentSetVersionModule,
        multivariateModule,
        contentTemplateModule,
        contentTypeModule,
        zoneEnquiryModule,
        creativeEnquiryModule,
        contentScenarioTypeModule,
        campaignDeliveryTypeModule
    }
});
